/**
 * Mappa i codici WMO (World Meteorological Organization) in icone e descrizioni italiane.
 * Open-Meteo restituisce `weathercode` nei dati daily.
 * Ref: https://open-meteo.com/en/docs#weathervariables
 */

const WMO_CODES = {
    0: { icon: '☀️', label: 'Sereno', severity: 'good' },
    1: { icon: '🌤️', label: 'Prevalentemente sereno', severity: 'good' },
    2: { icon: '⛅', label: 'Parzialmente nuvoloso', severity: 'good' },
    3: { icon: '☁️', label: 'Coperto', severity: 'neutral' },
    45: { icon: '🌫️', label: 'Nebbia', severity: 'caution' },
    48: { icon: '🌫️', label: 'Nebbia con brina', severity: 'caution' },
    51: { icon: '🌦️', label: 'Pioviggine leggera', severity: 'caution' },
    53: { icon: '🌦️', label: 'Pioviggine moderata', severity: 'caution' },
    55: { icon: '🌧️', label: 'Pioviggine intensa', severity: 'warning' },
    56: { icon: '🌧️', label: 'Pioggia gelata leggera', severity: 'warning' },
    57: { icon: '🌧️', label: 'Pioggia gelata intensa', severity: 'danger' },
    61: { icon: '🌧️', label: 'Pioggia leggera', severity: 'caution' },
    63: { icon: '🌧️', label: 'Pioggia moderata', severity: 'warning' },
    65: { icon: '🌧️', label: 'Pioggia intensa', severity: 'danger' },
    66: { icon: '🌧️', label: 'Pioggia gelata leggera', severity: 'warning' },
    67: { icon: '🌧️', label: 'Pioggia gelata intensa', severity: 'danger' },
    71: { icon: '🌨️', label: 'Neve leggera', severity: 'caution' },
    73: { icon: '🌨️', label: 'Neve moderata', severity: 'warning' },
    75: { icon: '❄️', label: 'Neve intensa', severity: 'danger' },
    77: { icon: '❄️', label: 'Granuli di neve', severity: 'warning' },
    80: { icon: '🌦️', label: 'Rovesci leggeri', severity: 'caution' },
    81: { icon: '🌧️', label: 'Rovesci moderati', severity: 'warning' },
    82: { icon: '🌧️', label: 'Rovesci violenti', severity: 'danger' },
    85: { icon: '🌨️', label: 'Rovesci di neve leggeri', severity: 'caution' },
    86: { icon: '❄️', label: 'Rovesci di neve intensi', severity: 'danger' },
    95: { icon: '⛈️', label: 'Temporale', severity: 'danger' },
    96: { icon: '⛈️', label: 'Temporale con grandine leggera', severity: 'danger' },
    99: { icon: '⛈️', label: 'Temporale con grandine forte', severity: 'danger' },
};

/**
 * Ottieni icona e descrizione dal weathercode WMO
 * @param {number} code - Codice WMO da Open-Meteo
 * @returns {{ icon: string, label: string, severity: string }}
 */
export function getWeatherCondition(code) {
    return WMO_CODES[code] || { icon: '❓', label: 'Dati non disponibili', severity: 'neutral' };
}

/**
 * Colore CSS per severity
 */
export function getSeverityColor(severity) {
    switch (severity) {
        case 'good': return '#4CAF50'; // verde
        case 'neutral': return '#9E9E9E'; // grigio
        case 'caution': return '#FF9800'; // arancione
        case 'warning': return '#F57C00'; // arancione scuro
        case 'danger': return '#F44336'; // rosso
        default: return '#9E9E9E';
    }
}